import React, { useEffect, useState } from "react";
import Sidebar from "../../components/admin/Sidebar";
import Navbar from "../../components/admin/Navbar";
import Footer from "../../components/Footer";
import LogoutModal from "../../components/admin/LogoutModal";
import Meta from "../../components/Meta";
// eslint-disable-next-line
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Loader from "../../components/Loader";
import { Button, Image, Modal, Table } from "react-bootstrap";
import DataTable from "react-data-table-component";
import api from "../../services/api";

const DashboardScreen = () => {
  const [motivo, setMotivo] = useState('');
  const [showMotivo, setShowMotivo] = useState(false);
  
  const [cpfCli, setCpfCli] = useState('');




  const [users, setUsers] = useState([]);
  const [show, setShow] = useState(false);
  const [dados, setDados] = useState({});
  const [nascimento, setNascimento] = useState("");
  const [dtEmissao, setDtEmissao] = useState("");
  const [estadoCivil, setEstadoCivil] = useState('');
  const [sexo, setSexo] = useState('');
  const [tipoDoc, setTipoDoc] = useState('');
  const [escolaridade, setEscolaridade] = useState('');
  const [PCD, setPCD] = useState('');
  const [estudante, setEstudante] = useState('');
  const [situacao, setSituacao] = useState("");
  const [dtDemissao, setdtDemissao] = useState("");
  const [dtAdmissao, setdtAdmissao] = useState("");
  const [tipoUser, setTipoUser] = useState("");
  const [status, setStatus] = useState(true);
  // eslint-disable-next-line
  const [loading, setLoading] = useState(true);
  const userInfoAdmin = JSON.parse(localStorage.getItem("userInfoAdmin"));

  function cont() {
    let conteudo = document.getElementById("print").innerHTML;
    let tela_impressao = window.open("about:blank");
    tela_impressao.document.write(conteudo);
    tela_impressao.window.print();
    tela_impressao.window.close();
  }

  const handlerdata = (dt) => {
    let dtForm = new Date(Date.parse(dt));
    return dtForm.toLocaleString().substr(0, 10);
  };

  const handlerFicha = async (cpf) => {
    setShow(true);
    const config = { headers: { "Content-Type": "application/json" } };
    const resp = await api.post("/api/users/ficha", { cpf: cpf }, config);
    setDados(resp.data);

    let nasc = new Date(Date.parse(resp.data.dtNascimento));
    setNascimento(nasc.toLocaleString().substr(0, 10));

    let dtemi = new Date(Date.parse(resp.data.dtEmissao));
    resp.data.dtEmissao != null
      ? setDtEmissao(dtemi.toLocaleString().substr(0, 10))
      : setDtEmissao("");

    let dtAdmi = new Date(Date.parse(resp.data.dtAdmissao));
    resp.data.dtAdmissao != null
      ? setdtAdmissao(dtAdmi.toLocaleString().substr(0, 10))
      : setdtAdmissao("");

    let dtDemi = new Date(Date.parse(resp.data.dtDemissao));
    resp.data.dtDemissao != null
      ? setdtDemissao(dtDemi.toLocaleString().substr(0, 10))
      : setdtDemissao("");

    const expr_esco = resp.data.escolaridade;
    switch (expr_esco) {
      case "1":
        setEscolaridade("Sem escolaridade");
        break;
      case "2":
        setEscolaridade("Analfabeto");
        break;
      case "3":
        setEscolaridade("Alfabetizado");
        break;
      case "4":
        setEscolaridade("Ensino fundamental completo");
        break;
      case "5":
        setEscolaridade("Ensino fundamental incompleto");
        break;
      case "6":
        setEscolaridade("Ensino médio completo");
        break;
      case "7":
        setEscolaridade("Ensino médio incompleto");
        break;
      case "8":
        setEscolaridade("Ensino superior completo");
        break;
      case "9":
        setEscolaridade("Ensino superior incompleto");
        break;
      case "10":
        setEscolaridade("Pós-graduação completa");
        break;

      case "11":
        setEscolaridade("Pós-graduação incompleta");
        break;
      case "12":
        setEscolaridade("Mestrado");
        break;
      default:
        console.log(``);
    }

    const expr_ec = resp.data.estadoCivil;
    switch (expr_ec) {
      case 1:
        setEstadoCivil("Solteiro");
        break;
      case 2:
        setEstadoCivil("Casado");
        break;
      case 3:
        setEstadoCivil("Viúvo");
        break;
      case 4:
        setEstadoCivil("Divorciado");
        break;
      case 5:
        setEstadoCivil("Separado");
        break;
      case 6:
        setEstadoCivil("União Estável");
        break;
      default:
        console.log(``);
    }

    const expr_tipoUser = resp.data.tipoUser;
    switch (expr_tipoUser) {
      case "PG":
        setTipoUser("PÚBLICO EM GERAL");
        break;
      case "TC":
        setTipoUser("TRABALAHADOR DO COMÉRCIO");
        break;
      default:
        console.log(``);
    }

    const expr_estudante = resp.data.estudante;
    switch (expr_estudante) {
      case "S":
        setEstudante("SIM");
        break;
      case "N":
        setEstudante("NÃO");
        break;
      default:
        console.log(``);
    }

    const expr_pcd = resp.data.deficiente;
    switch (expr_pcd) {
      case "S":
        setPCD("SIM");
        break;
      case "N":
        setPCD("NÃO");
        break;
      default:
        console.log(``);
    }

    const expr_sexo = resp.data.sexo;
    switch (expr_sexo) {
      case 1:
        setSexo("Masculino");
        break;
      case 2:
        setSexo("Feminino");
        break;
      default:
        console.log(``);
    }

    const expr_tp = resp.data.tipoDoc;
    switch (expr_tp) {
      case 1:
        setTipoDoc("Carteira de Identidade");
        break;
      case 2:
        setTipoDoc("Carteira Nacional de Habilitação");
        break;
      case 3:
        setTipoDoc("Carteira de Registro Profisisonal");
        break;
      case 4:
        setTipoDoc("Carteira de Trabalho");
        break;
      case 5:
        setTipoDoc("Certidão de Nascimento");
        break;
      case 6:
        setTipoDoc("Certificado de Reservista");
        break;
      case 7:
        setTipoDoc("Passaporte");
        break;
      case 8:
        setTipoDoc("Registro Nacional de Estrangeiro");
        break;

      default:
        console.log(``);
    }

    const expr_sprof = resp.data.situacao;
    switch (expr_sprof) {
      case 1:
        setSituacao("Empregado");
        break;
      case 2:
        setSituacao("Aposentado");
        break;
      case 3:
        setSituacao("Estagiário");
        break;
      case 4:
        setSituacao("Jovem Aprendiz");
        break;
      case 5:
        setSituacao("Trabalhador Temporário");
        break;
      case 6:
        setSituacao("Desempregado");
        break;
      case 7:
        setSituacao("Falecido");
        break;
      case 8:
        setSituacao("Sem informações");
        break;

      default:
        console.log(``);
    }
  };

  {
    /* TABELA */
  }

  const columns = [
    {
      name: "CÓDIGO",
      selector: (row) => row._id,
      sortable: true,
    },
    {
      width: "30%",
      name: "NOME",
      selector: (row) => row.nome,
      sortable: true,
    },
    {
      name: "CPF",
      selector: (row) => row.cpf,
      sortable: true,
    },
    {
      width: "10%",
      name: "FICHA",
      button: true,
      cell: (row) => (
        <>
          <Button
            variant="warning"
            className="btn-sm"
            onClick={() => {
              row.statusDoc === 2 ? setStatus(false) : setStatus(true);
              handlerFicha(row.cpf);
            }}
          >
            <i className="fa fa-newspaper"></i> FICHA
          </Button>
        </>
      ),
    },

    {
      width: "15%",
      name: "DATA DA SOLICITAÇÃO",
      button: true,
      cell: (row) => (
        <>
          <td className="text-center">{handlerdata(row.updatedAt)}</td>
        </>
      ),
    },

    {
      width: "10%",
      name: "LIBERAR ACESSO",
      button: true,
      cell: (row) => (
        <>
          {/*  LIBERAR   */}

          {row.statusDoc === 1 ? (
            <Button
              variant="primary"
              className="btn-sm"
              onClick={(e) => {
                if (
                  window.confirm("Tem certeza que deseja habilitar o cliente ?")
                ) {
                  handlerAcesso(row.cpf, 1);
                }
              }}
            >
              <i className="fa fa-newspaper"></i> LIBERAR
            </Button>
          ) : (
            <Button variant="success" className="btn-sm" disabled>
              <i className="fa fa-newspaper"></i> LIBERAR
            </Button>
          )}
        </>
      ),
    },

    {
      width: "10%",
      name: "NEGAR ACESSO",
      button: true,
      cell: (row) => (
        <>
          {/*  NEGAR   */}

          {row.statusDoc === 1 ? (
            <Button
              variant="danger"
              className="btn-sm"
              onClick={(e) => {
                if (
                  window.confirm(
                    "Tem certeza que deseja NEGAR o acesso do cliente?"
                  )
                ) {
                  //handlerAcesso(row.cpf, 2);
                  setCpfCli(row.cpf);
                  setShowMotivo(true);
                }
              }}
            >
              <i className="fa fa-user"></i> NEGAR
            </Button>
          ) : (
            <Button variant="success" className="btn-sm" disabled>
              <i className="fa fa-user"></i> NEGAR
            </Button>
          )}
        </>
      ),
    },
  ];

  const handlerAcesso = async (cpf, status) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const resp = await api.post(
      "/api/users/acesso",
      { operador: userInfoAdmin._id, cpf: cpf, status: status },
      config
    );

    if (resp.data.statusDoc === 2 || resp.data.statusDoc === 0) {
      setStatus(false);
      document.location.reload(true);
    }
  };

  const submitMotivoHandler = async () => {
    try {
          
      const config = { headers: { "Content-Type": "application/json" } };
      const resp = await api.post(
        "/api/users/acesso",
        {
          operador: userInfoAdmin._id,
          cpf: cpfCli,
          status: 2,
          motivo: motivo,
        },
        config
      );

      toast.success("atualizado com sucesso!");

      if (resp.data.statusDoc === 2 || resp.data.statusDoc === 0) {
        setStatus(false);
        //document.location.reload(true);
      }


  
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      toast.error(err);
    }
  };

  useEffect(() => {
    const pesquisaCard = async () => {
      const config = { headers: { "Content-Type": "application/json" } };
      const resp = await api.get("/api/users/docs", config);
      setUsers(resp.data);
     
      setLoading(false);
    };

    if (loading) {
      pesquisaCard();
    }
    // eslint-disable-next-line
  }, []);

  const data = users;

  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  return (
    <>
      <ToastContainer />
      <Meta />

      <div id="wrapper">
        <Sidebar />

        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />

            {loading ? (
              <Loader />
            ) : (
              <div className="container-fluid">
                <div className="d-sm-flex align-items-center justify-content-between mb-4"></div>

                <DataTable
                  title="Gerencimento do CRC"
                  columns={columns}
                  data={data}
                  pagination
                  paginationComponentOptions={paginationComponentOptions}
                />
              </div>
            )}
          </div>

          <Footer />
        </div>
      </div>
      <LogoutModal />

      {/*
       
       MODAL FICHA DA CLIENTELA 
     
     
     */}

      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        size="xl"
        className="conteudo"
        id="print"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Ficha Clientela - {tipoUser}
            </h5>

            <Button
              variant="success"
              className="btn-sm"
              style={{ textAlign: "right" }}
              onClick={(e) => {
                cont();
              }}
              value="Imprimir Div separadamente"
            >
              {" "}
              Imprimir
            </Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table
            width="774"
            height="872"
            border="0"
            className="table-borderless table-sm responsive"
          >
            <tbody>
              <tr>
                <td width="218" height="21" valign="top">
                  <strong>Nome</strong>
                </td>
                <td width="213" valign="top">
                  <strong>CPF:</strong>
                </td>
                <td width="161" valign="top">
                  <strong>Data de nascimento:</strong>
                </td>
                <td width="164" valign="top">
                  <strong>Estado Cívil:</strong>
                </td>
              </tr>
              <tr>
                <td height="43" valign="top">
                  {" "}
                  {dados.nome}{" "}
                </td>
                <td width="213" valign="top">
                  {" "}
                  {dados.cpf}{" "}
                </td>
                <td width="161" valign="top">
                  {" "}
                  {nascimento}{" "}
                </td>
                <td width="164" valign="top">
                  {" "}
                  {estadoCivil}{" "}
                </td>
              </tr>
              <tr>
                <td height="22" valign="top">
                  <strong>Nome social:</strong>
                </td>
                <td valign="top">
                  <strong>Sexo:</strong>
                </td>
                <td valign="top">
                  <strong>Nº Dependentes:</strong>
                </td>
                <td valign="top">&nbsp;</td>
              </tr>
              <tr>
                <td height="69" valign="top">
                  {" "}
                  {dados.nomeSocial}{" "}
                </td>
                <td valign="top">{sexo}</td>
                <td valign="top">{dados.dependente}</td>
                <td valign="top">&nbsp;</td>
              </tr>
              <tr>
                <td height="23" valign="top">
                  <strong>Documento:</strong>
                </td>
                <td valign="top">
                  <strong>Nº da documentação</strong>:{" "}
                </td>
                <td valign="top">
                  <strong>Orgão emissor: </strong>
                </td>
                <td valign="top">
                  <strong>Emissão do documento:</strong>
                </td>
              </tr>
              <tr>
                <td height="40" valign="top">
                  {" "}
                  {tipoDoc}{" "}
                </td>
                <td valign="top">{dados.docIdentificacao}</td>
                <td valign="top">{dados.orgEmissor}</td>
                <td valign="top">{dtEmissao}</td>
              </tr>
              <tr>
                <td height="23" valign="top">
                  <strong>Escolaridade:</strong>
                </td>
                <td valign="top">
                  <strong>Última serie:</strong>
                </td>
                <td valign="top">
                  <strong>Estudante?</strong>
                </td>
                <td valign="top">
                  <strong>PCD?</strong>
                </td>
              </tr>
              <tr>
                <td valign="top">{escolaridade}</td>
                <td valign="top">{dados.ultimaSerie}</td>
                <td valign="top">{estudante}</td>
                <td valign="top">{PCD}</td>
              </tr>
              <tr>
                <td height="22" valign="top">
                  <strong>Nome do pai:</strong>
                </td>
                <td valign="top">
                  <strong>Nome da mãe:</strong>
                </td>
                <td valign="top">
                  <strong>Nacionalidade:</strong>
                </td>
                <td valign="top">
                  <strong>Naturalidade:</strong>
                </td>
              </tr>
              <tr>
                <td height="40" valign="top">
                  {" "}
                  {dados.nomePai}{" "}
                </td>
                <td valign="top">{dados.nomeMae}</td>
                <td valign="top">{dados.nacionalidade}</td>
                <td valign="top">{dados.naturalidade}</td>
              </tr>
              <tr>
                <td height="21" valign="top">
                  <strong>Fone 1:</strong>
                </td>
                <td valign="top">
                  <strong>Fone 2:</strong>
                </td>
                <td valign="top">&nbsp;</td>
                <td valign="top">&nbsp;</td>
              </tr>
              <tr>
                <td height="60" valign="top">
                  {" "}
                  {dados.fone1}{" "}
                </td>
                <td valign="top">{dados.fone2}</td>
                <td valign="top">&nbsp;</td>
                <td valign="top">&nbsp;</td>
              </tr>
              <tr>
                <td height="21" valign="top">
                  <strong>CEP:</strong>
                </td>
                <td valign="top">
                  <strong>Logradouro:</strong>
                </td>
                <td valign="top">
                  <strong>Número:</strong>
                </td>
                <td valign="top">&nbsp;</td>
              </tr>
              <tr>
                <td height="47" valign="top">
                  {" "}
                  {dados.cep}{" "}
                </td>
                <td valign="top">{dados.logradouro}</td>
                <td valign="top">{dados.numero}</td>
                <td valign="top">&nbsp;</td>
              </tr>
              <tr>
                <td height="21" valign="top">
                  <strong>Bairro:</strong>
                </td>
                <td valign="top">
                  <strong>Cidade:</strong>
                </td>
                <td valign="top">
                  <strong>Estado:</strong>
                </td>
                <td valign="top">&nbsp;</td>
              </tr>
              <tr>
                <td height="81" valign="top">
                  {" "}
                  {dados.bairro}{" "}
                </td>
                <td valign="top">{dados.cidade}</td>
                <td valign="top">{dados.estado}</td>
                <td valign="top">&nbsp;</td>
              </tr>
              {dados.tipoUser === "TC" ? (
                <>
                  <tr>
                    <td height="21" valign="top">
                      <strong>Situação Profisional:</strong>
                    </td>
                    <td valign="top">
                      <strong>CNPJ:</strong>
                    </td>
                    <td valign="top">
                      <strong>Admissão:</strong>
                    </td>
                    <td valign="top">
                      <strong>Demissão:</strong>
                    </td>
                  </tr>
                  <tr>
                    <td height="39" valign="top">
                      {" "}
                      {situacao}{" "}
                    </td>
                    <td valign="top">{dados.cnpj}</td>
                    <td valign="top">{dtAdmissao}</td>
                    <td valign="top">{dtDemissao}</td>
                  </tr>
                  <tr>
                    <td height="21" valign="top">
                      <strong>CTPS:</strong>
                    </td>
                    <td valign="top">
                      <strong>Cargo Social:</strong>
                    </td>
                    <td valign="top">
                      <strong>Renda:</strong>
                    </td>
                    <td valign="top">
                      <strong>Renda Familiar:</strong>
                    </td>
                  </tr>
                  <tr>
                    <td height="43" valign="top">
                      {" "}
                      {dados.ctps}{" "}
                    </td>
                    <td valign="top">{dados.cargo}</td>
                    <td valign="top">R$ {dados.renda}</td>
                    <td valign="top">R$ {dados.rendaFamiliar}</td>
                  </tr>
                  <tr>
                    <td height="21" valign="top">
                      <strong>Série:</strong>
                    </td>
                    <td valign="top">
                      <strong>PIS/PASEP:</strong>
                    </td>
                    <td valign="top">&nbsp;</td>
                    <td valign="top">&nbsp;</td>
                  </tr>
                  <tr>
                    <td valign="top">{dados.serie}</td>
                    <td valign="top">{dados.pis_pasep}</td>
                    <td valign="top">&nbsp;</td>
                    <td valign="top">&nbsp;</td>
                  </tr>
                  <tr>
                    <td valign="top">&nbsp;</td>
                    <td valign="top">&nbsp;</td>
                    <td valign="top">&nbsp;</td>
                    <td valign="top">&nbsp;</td>
                  </tr>

                  {/*
                  
                    STATUS DOS DOCUMENTOS 
                  
                  
                  
                  */}

                  {status === true ? (
                    <>
                      <tr>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          {" "}
                          Perfil{" "}
                        </td>
                        <td align="center" valign="top">
                          {" "}
                          Comprovante de Residência{" "}
                        </td>
                        <td align="center" valign="top">
                          {" "}
                          Contrato{" "}
                        </td>
                        <td align="center" valign="top">
                          {" "}
                          Contra Cheque{" "}
                        </td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          <Image
                            src={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docPerfil
                            }
                            className="img-thumbnail mt-2 mb-2"
                            width="100"
                            height="200"
                            responsive
                          />
                        </td>
                        <td align="center" valign="top">
                          <Image
                            src={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docComprovante
                            }
                            className="img-thumbnail mt-2 mb-2"
                            width="100"
                            height="200"
                            responsive
                          />
                        </td>
                        <td align="center" valign="top">
                          <Image
                            src={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docContrato
                            }
                            className="img-thumbnail mt-2 mb-2"
                            width="100"
                            height="200"
                            responsive
                          />
                        </td>
                        <td align="center" valign="top">
                          <Image
                            src={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docHolerite
                            }
                            className="img-thumbnail mt-2 mb-2"
                            width="100"
                            height="200"
                            responsive
                          />
                        </td>
                      </tr>
                      <tr>
                        <td height="75" align="center" valign="top">
                          <a
                            href={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docPerfil
                            }
                            download={dados.docPerfil}
                            target="_blank"
                            rel="noreferrer"
                          >
                            baixar arquivo
                            {dados.docPerfil}
                          </a>
                        </td>
                        <td align="center" valign="top">
                          <a
                            href={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docComprovante
                            }
                            download={dados.docComprovante}
                            target="_blank"
                            rel="noreferrer"
                          >
                            baixar arquivo
                            {dados.docComprovante}{" "}
                          </a>
                        </td>
                        <td align="center" valign="top">
                          <a
                            href={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docContrato
                            }
                            download={dados.docContrato}
                            target="_blank"
                            rel="noreferrer"
                          >
                            baixar arquivo
                            {dados.docContrato}
                          </a>
                        </td>
                        <td align="center" valign="top">
                          <a
                            href={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docHolerite
                            }
                            download={dados.docHolerite}
                            target="_blank"
                            rel="noreferrer"
                          >
                            baixar arquivo
                            {dados.docHolerite}
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          Holerite
                        </td>
                        <td align="center" valign="top">
                          CTPS
                        </td>
                        <td align="center" valign="top">
                          Documento - Frente
                        </td>
                        <td align="center" valign="top">
                          Documento - Verso
                        </td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          <Image
                            src={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docHolerite
                            }
                            className="img-thumbnail mt-2 mb-2"
                            width="100"
                            height="200"
                            responsive
                          />
                        </td>
                        <td align="center" valign="top">
                          <Image
                            src={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docCTPS
                            }
                            className="img-thumbnail mt-2 mb-2"
                            width="100"
                            height="200"
                            responsive
                          />
                        </td>
                        <td align="center" valign="top">
                          <Image
                            src={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docFrente
                            }
                            className="img-thumbnail mt-2 mb-2"
                            width="100"
                            height="200"
                            responsive
                          />
                        </td>
                        <td align="center" valign="top">
                          <Image
                            src={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docVerso
                            }
                            className="img-thumbnail mt-2 mb-2"
                            width="100"
                            height="200"
                            responsive
                          />
                        </td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          <a
                            href={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docHolerite
                            }
                            download={dados.docHolerite}
                            target="_blank"
                            rel="noreferrer"
                          >
                            baixar arquivo
                            {dados.docHolerite}
                          </a>
                        </td>
                        <td align="center" valign="top">
                          <a
                            href={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docCTPS
                            }
                            download={dados.docCTPS}
                            target="_blank"
                            rel="noreferrer"
                          >
                            baixar arquivo
                            {dados.docCTPS}
                          </a>
                        </td>
                        <td align="center" valign="top">
                          <a
                            href={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docFrente
                            }
                            download={dados.docFrente}
                            target="_blank"
                            rel="noreferrer"
                          >
                            baixar arquivo
                            {dados.docFrente}
                          </a>
                        </td>
                        <td align="center" valign="top">
                          <a
                            href={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docVerso
                            }
                            download={dados.docVerso}
                            target="_blank"
                            rel="noreferrer"
                          >
                            baixar arquivo
                            {dados.docVerso}
                          </a>
                        </td>
                      </tr>

                      <tr>
                        <td align="center" valign="top">
                          CPF
                        </td>
                        <td align="center" valign="top"></td>
                        <td align="center" valign="top"></td>
                        <td align="center" valign="top"></td>
                      </tr>

                      <tr>
                        <td align="center" valign="top">
                          <Image
                            src={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docCpf
                            }
                            className="img-thumbnail mt-2 mb-2"
                            width="100"
                            height="200"
                            responsive
                          />
                        </td>
                        <td align="center" valign="top"></td>
                        <td align="center" valign="top"></td>
                        <td align="center" valign="top"></td>
                      </tr>

                      <tr>
                        <td align="center" valign="top">
                          <a
                            href={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docCpf
                            }
                            download={dados.docCpf}
                            target="_blank"
                            rel="noreferrer"
                          >
                            baixar arquivo
                            {dados.docCpf}
                          </a>
                        </td>
                        <td align="center" valign="top"></td>
                        <td align="center" valign="top"></td>
                        <td align="center" valign="top"></td>
                      </tr>
                    </>
                  ) : null}
                </>
              ) : (
                <>
                  {/*
                  
                    STATUS DOS DOCUMENTOS 
                  
                  
                  
                  */}

                  {status === true ? (
                    <>
                      <tr>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                      </tr>
                      <tr>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          Perfil
                        </td>
                        <td align="center" valign="top">
                          {" "}
                          Comprovante de Residência{" "}
                        </td>
                        <td align="center" valign="top">
                          {" "}
                          Documento - Frente{" "}
                        </td>
                        <td align="center" valign="top">
                          {" "}
                          Documento - Verso{" "}
                        </td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          <Image
                            src={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docPerfil
                            }
                            className="img-thumbnail mt-2 mb-2"
                            width="100"
                            height="200"
                            responsive
                          />
                        </td>
                        <td align="center" valign="top">
                          <Image
                            src={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docComprovante
                            }
                            className="img-thumbnail mt-2 mb-2"
                            width="100"
                            height="200"
                            responsive
                          />
                        </td>
                        <td align="center" valign="top">
                          <Image
                            src={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docFrente
                            }
                            className="img-thumbnail mt-2 mb-2"
                            width="100"
                            height="200"
                            responsive
                          />
                        </td>
                        <td align="center" valign="top">
                          <Image
                            src={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docVerso
                            }
                            className="img-thumbnail mt-2 mb-2"
                            width="100"
                            height="200"
                            responsive
                          />
                        </td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          <a
                            href={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docPerfil
                            }
                            download={dados.docPerfil}
                            target="_blank"
                            rel="noreferrer"
                          >
                            baixar arquivo -
                            {dados.docPerfil}
                          </a>
                        </td>
                        <td align="center" valign="top">
                          <a
                            href={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docComprovante
                            }
                            download={dados.docComprovante}
                            target="_blank"
                            rel="noreferrer"
                          >
                            baixar arquivo -
                            {dados.docComprovante}
                          </a>
                        </td>
                        <td align="center" valign="top">
                          <a
                            href={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docFrente
                            }
                            download={dados.docFrente}
                            target="_blank"
                            rel="noreferrer"
                          >
                            baixar arquivo -
                            {dados.docFrente}
                          </a>
                        </td>
                        <td align="center" valign="top">
                          <a
                            href={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docVerso
                            }
                            download={dados.docVerso}
                            target="_blank"
                            rel="noreferrer"
                          >
                            baixar arquivo -
                            {dados.docVerso}
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          &nbsp;
                        </td>
                        <td align="center" valign="top">
                          &nbsp;
                        </td>
                        <td align="center" valign="top">
                          &nbsp;
                        </td>
                        <td align="center" valign="top">
                          &nbsp;
                        </td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          CPF{" "}
                        </td>
                        <td align="center" valign="top">
                          &nbsp;
                        </td>
                        <td align="center" valign="top">
                          &nbsp;
                        </td>
                        <td align="center" valign="top">
                          &nbsp;
                        </td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          <Image
                            src={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docCpf
                            }
                            className="img-thumbnail mt-2 mb-2"
                            width="100"
                            height="200"
                            responsive
                          />
                        </td>
                        <td align="center" valign="top">
                          &nbsp;
                        </td>
                        <td align="center" valign="top">
                          &nbsp;
                        </td>
                        <td align="center" valign="top">
                          &nbsp;
                        </td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          <a
                            href={
                              process.env.REACT_APP_CLIENT_URL +
                              "/" +
                              dados.docCpf
                            }
                            download={dados.docCpf}
                            target="_blank"
                            rel="noreferrer"
                          >
                            baixar arquivo -
                            {dados.docCpf}
                          </a>
                        </td>
                        <td align="center" valign="top">
                          &nbsp;
                        </td>
                        <td align="center" valign="top">
                          &nbsp;
                        </td>
                        <td align="center" valign="top">
                          &nbsp;
                        </td>
                      </tr>
                    </>
                  ) : null}
                </>
              )}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>

      {/*    MODAL MOTIVO - NEGAÇÃO    */}

      <Modal
        show={showMotivo}
        onHide={() => setShowMotivo(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        size="lg"
        className="conteudo"
        id="print"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Motivo - negação de acesso
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* formulario de cadastro  */}

          <form className="user" onSubmit={submitMotivoHandler}>
            <div className="form-group row">
              <div className="col-sm-6 mb-3 mb-sm-0">
                <textarea
                  className="form-control"
                  rows="5"
                  id="motivo"
                  value={motivo}
                  onChange={(e) => setMotivo(e.target.value)}
                ></textarea>
              </div>

              <div className="col-sm-6 mb-3 mb-sm-0"></div>
            </div>

            <div className="form-group row">
              <div className="col-sm-6 mb-3 mb-sm-0">
                <Button
                  type="submit"
                  className="btn btn-primary btn-user btn-block"
                >
                  Salvar
                </Button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DashboardScreen;
